import 'waypoints/lib/noframework.waypoints';

window.Waypoint = Waypoint;
